
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#D64C10"}}),_c('path',{attrs:{"d":"M18.09 10.53a.86.86 0 00-.84-.441.908.908 0 00-.774.618 4.93 4.93 0 01-.392.903 9.76 9.76 0 00.056-1.082 6.653 6.653 0 00-2.185-4.923.897.897 0 00-.901-.183.869.869 0 00-.576.695 10.207 10.207 0 01-1.17 3.407 5.745 5.745 0 00-.256-.932.881.881 0 00-.832-.575h-.01a.872.872 0 00-.82.586c-.326.92-.6 1.637-1.176 2.5-.829 1.242-1.232 2.456-1.232 3.708a5.915 5.915 0 005.908 5.908 5.915 5.915 0 005.908-5.908c0-1.829-.278-3.51-.708-4.28z","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.157 16.212h.001c-.071-.502-.956-1.978-1.543-2.902a.591.591 0 00-.973-.03c-.596.79-1.489 1.954-1.704 2.267a2.363 2.363 0 104.219.665z","fill":"#D64C10"}})])
          )
        }
      }
    